import { brandOf } from "../domains";
import { DIRECTORY_SITES } from "./directoryList";
import { NATIONAL_SITES } from "./nationalList";
import { FRANCHISE_SITES } from "./franchiseList";
import { LEAD_GEN_SITES } from "./leadGenList";

// Every business type AdAudit can classify an advertiser as.
export const BUSINESS_TYPES = ["local", "national", "franchise", "directory", "lead_gen", "unclassified"];

// The built-in lists, checked in this order.
export const BUILT_IN_LISTS = {
  directory: DIRECTORY_SITES,
  national: NATIONAL_SITES,
  franchise: FRANCHISE_SITES,
  lead_gen: LEAD_GEN_SITES,
};

// AdAudit's classification of one advertiser. First match wins:
//   1. a manual correction (overrides: { [advertiser key]: type }) -> basis "manual"
//   2. the advertiser's website is on a built-in list             -> basis "list"
//   3. it has a map pack listing in this job                      -> "local", basis "rule"
//   4. otherwise                                                  -> "unclassified", basis "none"
// advertiser = { key, domain, hasMapListing }
export function classifyBusiness(advertiser, lists = BUILT_IN_LISTS, overrides = {}) {
  const manual = overrides[advertiser.key];
  if (manual && BUSINESS_TYPES.includes(manual)) return { type: manual, basis: "manual" };

  if (advertiser.domain) {
    for (const [type, sites] of Object.entries(lists)) {
      if ((sites || []).some(site => brandOf(site) === advertiser.domain)) return { type, basis: "list" };
    }
  }

  if (advertiser.hasMapListing) return { type: "local", basis: "rule" };
  return { type: "unclassified", basis: "none" };
}
